import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, skip, Subject } from 'rxjs';
import { debounceTime, delay, filter, take, takeUntil, tap } from 'rxjs/operators';

import { VideoArchiveIdsResponse } from 'src/app/features/video/models';
import { VideoActions, VideoSelectors } from 'src/app/features/video/store';

import { RootStoreState } from 'src/app/store';

@Component({
    selector: 'app-download-video-button',
    templateUrl: './download-video-button.component.html',
    styleUrls: ['./download-video-button.component.scss'],
    standalone: false
})
export class DownloadVideoButtonComponent implements OnInit, OnDestroy {
  videoDownloadArchiveIds$: Observable<VideoArchiveIdsResponse>;
  videoArchiveDownloadStatus$: Observable<boolean>;

  doesAnyVideoUrlExist$: Observable<boolean>;
  isDownloadingMultiVideoStorageLocatorUrls: boolean[]; // this name is terrible
  onDestroyNotifier$ = new Subject<void>();

  constructor(
    private readonly store: Store<RootStoreState.State>
  ) { }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next(undefined);
    this.onDestroyNotifier$.complete();
  }

  ngOnInit(): void {
    this.store.dispatch(VideoActions.GetMultiVideoStorageLocatorUrls());
    this.doesAnyVideoUrlExist$ = this.store.select(
      VideoSelectors.areMultiVideoStorageLocatorUrlsAvailable);

    this.store
      .select(VideoSelectors.getMultiVideoStorageLocatorUrls)
      .pipe(
        filter((urls) => !!urls),
        take(1),
        tap((urls) => {
          this.isDownloadingMultiVideoStorageLocatorUrls = new Array(urls.length).fill(false);
        })
      )
      .subscribe();
  }

  onVideoButtonClick(videoArchiveId: number): void {
    this.store.dispatch(VideoActions.FetchVideo({ payload: { videoArchiveId } }));
  }

  onMultiVideoStorageLocatorButtonClick(index: number): void {
    this.isDownloadingMultiVideoStorageLocatorUrls[index] = true;
    this.store.dispatch(VideoActions.GetMultiVideoStorageLocatorUrls());
    this.store
      .select(VideoSelectors.getMultiVideoStorageLocatorUrls)
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        skip(1),
        debounceTime(300),
        tap((urls) => {
          if (urls) {
            this.downloadFile(urls[index].toString());
            delay(2000);
            this.isDownloadingMultiVideoStorageLocatorUrls[index] = false;
          }
        })
      )
      .subscribe();
  }

  downloadFile(url: string) {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  fetchDownloadUrls(): void {
    this.store.dispatch(VideoActions.GetVideoArchiveStatus());
    this.store.dispatch(VideoActions.FetchDownloadVideoArchiveIds());
  }
}
